import React, { useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const ButtonWithDropdown = ({ idx, icone, options = [], callbackAction = () => {} }) => {
    const [kebabToggle, setKebabToggle] = useState(false);
    
  return (
    <UncontrolledDropdown
      id={idx}
      isOpen={kebabToggle}
      toggle={() => setKebabToggle(!kebabToggle)}
    >
      <DropdownToggle className="border-0 bg-transparent" tag="button"><i className={icone} />
      </DropdownToggle>
      <DropdownMenu className="dropdown-kebab-custom-table dropdown-menu-end">
        {options?.map((option) => (            
          <DropdownItem onClick={() => callbackAction(option?.action)} className="d-flex align-items-center gap-2"><i className={`font-size-16 ${option?.icone}`} /> {option?.label}</DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ButtonWithDropdown;
